import React, { useEffect } from 'react';
import { AlertCircle, X } from 'lucide-react';

interface AuthErrorBannerProps {
  message: string;
  onDismiss: () => void;
  autoHideMs?: number;
}

const AuthErrorBanner: React.FC<AuthErrorBannerProps> = ({
  message,
  onDismiss,
  autoHideMs = 6000,
}) => {
  useEffect(() => {
    const timer = window.setTimeout(onDismiss, autoHideMs);
    return () => window.clearTimeout(timer);
  }, [message, onDismiss, autoHideMs]);

  return (
    <div className="auth-error-banner" role="alert" aria-live="assertive">
      <div className="auth-error-banner__icon" aria-hidden="true">
        <AlertCircle size={20} strokeWidth={2} />
      </div>
      <p className="auth-error-banner__text">{message}</p>
      <button
        type="button"
        className="auth-error-banner__close"
        onClick={onDismiss}
        aria-label="Dismiss error"
      >
        <X size={18} strokeWidth={2} />
      </button>
    </div>
  );
};

export default AuthErrorBanner;
